(function(){
  'use strict';

  var originalFetch=window.fetch;
  var fetchPatched=false;

  function N(v){return String(v||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim()}
  function money(cents){
    var amount=(Number(cents)||0)/100;
    try{return new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR',minimumFractionDigits:Number.isInteger(amount)?0:2,maximumFractionDigits:2}).format(amount)}catch(e){return amount.toFixed(2).replace('.',',')+' €'}
  }
  function swatch(value){
    var v=N(value);
    if(/noir|black|minuit|gris sideral|graphite/.test(v))return'#4b4e53';
    if(/blanc|white/.test(v))return'#f5f5f2';
    if(/argent|silver/.test(v))return'#d7d9dc';
    if(/or rose|rose|pink/.test(v))return'#e9c3bd';
    if(v==='or'||/gold|stellaire/.test(v))return'#e5d2a7';
    if(/bleu|blue|pacifique|sierra/.test(v))return'#9fb7ca';
    if(/vert|green/.test(v))return'#a9bfad';
    if(/rouge|red/.test(v))return'#c94d4b';
    if(/violet|purple|mauve/.test(v))return'#b9a7c8';
    if(/jaune|yellow/.test(v))return'#eadb78';
    return'#e6e7e9';
  }
  function isIphonePage(){
    var product=document.querySelector('[data-product]');
    var title=product&&product.querySelector('.product__title');
    if(title&&title.textContent.toLowerCase().indexOf('iphone')!==-1)return true;
    return /\/products\/[^/?]*iphone/i.test(window.location.pathname);
  }
  function batteryPriceTestEnabled(){
    return isIphonePage();
  }
  function batteryPrices(baseCents){
    var base=Number(baseCents)||0;
    if(!batteryPriceTestEnabled())return{standard:base,excellent:base,newBattery:base};
    var excellentRate=base<=15000?1.10:(base<=30000?1.06:1.05);
    var newRate=base<=15000?1.20:1.08;
    return{
      standard:base,
      excellent:Math.round(base*excellentRate),
      newBattery:Math.round(base*newRate)
    };
  }
  function productRoot(form){return form&&(form.closest('[data-product]')||document)}
  function variantData(form){
    var root=productRoot(form),el=root&&root.querySelector('[data-variants-json]');
    if(!el)return[];
    try{var data=JSON.parse(el.textContent||'[]');return Array.isArray(data)?data:[]}catch(e){return[]}
  }
  function selectedOptions(form,count){
    var out=[];
    for(var i=1;i<=count;i++){
      var checked=form.querySelector('input[name="option-'+i+'"]:checked');
      out.push(checked?checked.value:null);
    }
    return out;
  }
  function optionPosition(group){
    var input=group.querySelector('input[name^="option-"]');
    var match=input&&input.name.match(/option-(\d+)/);
    return match?parseInt(match[1],10)-1:-1;
  }
  function groupType(group){
    var label=group.querySelector('.option__label'),name=N(label?label.textContent:'');
    if(/couleur|color/.test(name))return'color';
    if(/etat|grade|condition/.test(name))return'grade';
    return'priced';
  }
  function labelFor(form,input){return input&&input.id?form.querySelector('label[for="'+input.id.replace(/"/g,'\\"')+'"]'):null}
  function exactVariant(variants,options){
    return variants.find(function(v){return v.options&&v.options.length===options.length&&v.options.every(function(o,i){return o===options[i]})})||null;
  }
  function bestVariant(variants,selected,pos,value){
    var options=selected.slice();options[pos]=value;
    var exact=exactVariant(variants,options);if(exact)return exact;
    var candidates=variants.filter(function(v){
      if(!v.options||v.options[pos]!==value)return false;
      for(var i=0;i<pos;i++){if(selected[i]&&v.options[i]!==selected[i])return false}
      return true;
    });
    if(!candidates.length)return null;
    candidates.sort(function(a,b){
      function score(v){var s=v.available===false?0:5;for(var i=0;i<selected.length;i++){if(i!==pos&&selected[i]&&v.options[i]===selected[i])s+=12}return s}
      return score(b)-score(a);
    });
    return candidates[0];
  }

  function patchCartFetch(){
    if(fetchPatched||!originalFetch)return;
    fetchPatched=true;
    window.fetch=function(input,init){
      try{
        var url=typeof input==='string'?input:(input&&input.url?input.url:'');
        if(isIphonePage()&&/\/cart\/add(?:\.js)?(?:\?|$)/.test(url)&&init&&typeof init.body==='string'){
          var property=document.querySelector('form[data-product-form] [data-mxp-battery-property]');
          if(property&&property.value){
            var payload=JSON.parse(init.body);
            if(payload&&Array.isArray(payload.items)){
              payload.items.forEach(function(item){item.properties=item.properties||{};item.properties['État de la batterie']=property.value});
              init=Object.assign({},init,{body:JSON.stringify(payload)});
            }
          }
        }
      }catch(error){}
      return originalFetch.call(window,input,init);
    };
  }

  function enhanceNativeOptions(form){
    if(!form||form.dataset.mxpOptionPrices==='1')return;
    var variants=variantData(form);if(!variants.length)return;
    var shell=form.querySelector('.mps-product-options');if(!shell)return;
    var groups=Array.prototype.slice.call(shell.querySelectorAll(':scope > .option'));
    if(!groups.length)return;
    form.dataset.mxpOptionPrices='1';
    var meta=[];

    groups.forEach(function(group){
      var pos=optionPosition(group);if(pos<0)return;
      var type=groupType(group),inputs=Array.prototype.slice.call(group.querySelectorAll('input[name="option-'+(pos+1)+'"]'));
      if(!inputs.length)return;
      group.classList.add(type==='color'?'mps-option-color':type==='grade'?'mps-option-grade':'mps-option-priced');
      inputs.forEach(function(input){
        var label=labelFor(form,input);if(!label)return;
        if(type==='color'){
          if(!label.querySelector('.mps-option-color__swatch')){
            label.textContent='';
            label.style.setProperty('grid-template-columns','20px minmax(0,1fr) auto','important');
            var dot=document.createElement('span');dot.className='mps-option-color__swatch';dot.style.background=swatch(input.value);
            var name=document.createElement('span');name.className='mps-option-color__name';name.textContent=input.value;
            var price=document.createElement('span');price.className='mps-option-color__price';price.setAttribute('data-mps-color-price','');price.textContent='—';price.style.justifySelf='end';price.style.color='#4f555e';price.style.fontSize='12px';price.style.fontWeight='900';price.style.whiteSpace='nowrap';
            label.appendChild(dot);label.appendChild(name);label.appendChild(price);
          }
        }else if(type==='priced'){
          if(!label.querySelector('[data-mps-option-price]')){
            label.textContent='';
            var radio=document.createElement('span');radio.className='mps-option-radio';radio.setAttribute('aria-hidden','true');
            var text=document.createElement('span');text.className='mps-option-name';text.textContent=input.value;
            var price=document.createElement('span');price.className='mps-option-price';price.setAttribute('data-mps-option-price','');price.textContent='—';
            label.appendChild(radio);label.appendChild(text);label.appendChild(price);
          }
        }
      });
      meta.push({group:group,pos:pos,type:type,inputs:inputs});
    });

    function sync(){
      var count=(variants[0].options||[]).length,selected=selectedOptions(form,count);
      meta.forEach(function(m){
        m.inputs.forEach(function(input){
          var candidates=variants.filter(function(v){
            if(!v.options||v.options[m.pos]!==input.value)return false;
            for(var i=0;i<m.pos;i++){if(selected[i]&&v.options[i]!==selected[i])return false}
            return true;
          });
          var label=labelFor(form,input),exists=candidates.length>0;
          if(label)label.classList.toggle('mps-option-gone',!exists);
          input.disabled=!exists;
          if(!exists)return;
          var variant=bestVariant(variants,selected,m.pos,input.value);
          if(!variant)return;
          if(m.type==='color'&&label){var colorPrice=label.querySelector('[data-mps-color-price]');if(colorPrice){colorPrice.textContent=money(variant.price);colorPrice.style.color=input.checked?'#087a48':'#4f555e'}}
          if(m.type==='priced'&&label){var price=label.querySelector('[data-mps-option-price]');if(price)price.textContent=money(variant.price)}
          if(m.type==='grade'&&label){var gradePrice=label.querySelector('[data-mps-grade-price]');if(gradePrice)gradePrice.textContent=money(variant.price);label.classList.remove('is-unavailable')}
        });
      });
      syncBatteryPrices(form);
    }
    form.addEventListener('change',function(e){if(e.target&&e.target.matches('input[name^="option-"]'))requestAnimationFrame(sync)});
    sync();
  }

  function syncBatteryPrices(form){
    if(!form)return;
    var picker=form.querySelector('[data-mxp-battery-picker]');if(!picker)return;
    var id=form.querySelector('input[name="id"]'),variants=variantData(form),variant=variants.find(function(v){return id&&String(v.id)===String(id.value)});
    if(!variant)return;
    var prices=batteryPrices(variant.price);
    Array.prototype.forEach.call(picker.querySelectorAll('[data-mxp-battery-choice]'),function(choice){
      var node=choice.querySelector('[data-mxp-battery-price]');if(!node)return;
      if(!batteryPriceTestEnabled()){node.textContent=money(variant.price);return;}
      var value=N(choice.getAttribute('data-value')||'');
      var cents=prices.standard;
      if(value.indexOf('excellente')!==-1)cents=prices.excellent;
      else if(value.indexOf('neuve')!==-1)cents=prices.newBattery;
      node.textContent=money(cents);
    });
  }

  function buildPicker(form){
    if(!form||form.querySelector('[data-mxp-battery-picker]'))return;
    var picker=document.createElement('div');
    picker.className='mxp-battery-picker';picker.setAttribute('data-mxp-battery-picker','');
    picker.innerHTML=''+
      '<div class="mxp-battery-picker__head"><div><span class="mxp-battery-picker__title">État de la batterie</span><span class="mxp-battery-picker__help">Choisissez le niveau de capacité souhaité pour votre iPhone.</span></div></div>'+
      '<input type="hidden" name="properties[État de la batterie]" value="Batterie standard — 80 à 89 %" data-mxp-battery-property>'+
      '<div class="mxp-battery-picker__options" role="group" aria-label="État de la batterie">'+
        '<button class="mxp-battery-choice is-selected" type="button" aria-pressed="true" data-mxp-battery-choice data-value="Batterie standard — 80 à 89 %"><span class="mxp-battery-choice__check">✓</span><span class="mxp-battery-choice__copy"><strong>Batterie standard</strong><small>80–89 % · Pour un usage quotidien</small></span><span class="mxp-battery-choice__price" data-mxp-battery-price>—</span></button>'+
        '<button class="mxp-battery-choice" type="button" aria-pressed="false" data-mxp-battery-choice data-value="Batterie excellente — 90 à 99 %"><span class="mxp-battery-choice__check">✓</span><span class="mxp-battery-choice__copy"><strong>Batterie excellente</strong><small>90–99 % · Très bonne autonomie</small></span><span class="mxp-battery-choice__price" data-mxp-battery-price>—</span></button>'+
        '<button class="mxp-battery-choice" type="button" aria-pressed="false" data-mxp-battery-choice data-value="Batterie neuve — 100 %"><span class="mxp-battery-choice__check">✓</span><span class="mxp-battery-choice__copy"><strong>Batterie neuve</strong><small>100 % · Capacité maximale</small></span><span class="mxp-battery-choice__price" data-mxp-battery-price>—</span></button>'+
      '</div>'+
      '<div class="mxp-battery-picker__note"><span>i</span><small>La capacité correspond à la santé de la batterie par rapport à une batterie neuve.</small></div>';
    var quantity=form.querySelector('.mps-product-quantity'),buyNow=form.querySelector('.product-form__buttons');
    if(quantity)form.insertBefore(picker,quantity);else if(buyNow)form.insertBefore(picker,buyNow);else form.appendChild(picker);
    var hidden=picker.querySelector('[data-mxp-battery-property]'),choices=picker.querySelectorAll('[data-mxp-battery-choice]');
    choices.forEach(function(button){button.addEventListener('click',function(){hidden.value=button.getAttribute('data-value')||'';choices.forEach(function(other){var selected=other===button;other.classList.toggle('is-selected',selected);other.setAttribute('aria-pressed',selected?'true':'false')})})});
    syncBatteryPrices(form);
  }

  function init(root){
    if(!isIphonePage())return;
    patchCartFetch();
    var scope=root&&root.querySelector?root:document;
    var form=scope.querySelector('form[data-product-form]')||document.querySelector('form[data-product-form]');
    if(!form)return;
    buildPicker(form);
    enhanceNativeOptions(form);
  }

  function boot(){init(document)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',function(event){init(event.target)});
})();

/* Test iPhone 16 Pro Max — nomenclature batterie iPhone, sans modifier les variantes Shopify. */
(function(){
  'use strict';
  if(!/\/products\/apple-iphone-16-pro-max(?:\/|$)/.test(window.location.pathname))return;
  if(window.__MXP_IPHONE16PM_BATTERY_LABELS_V1__)return;
  window.__MXP_IPHONE16PM_BATTERY_LABELS_V1__=true;

  var LABELS={
    standard:{value:'Batterie standard — 80–89 %',title:'Batterie standard — 80–89 %',sub:'Pour un usage quotidien'},
    excellent:{value:'Batterie excellente — 90–99 %',title:'Batterie excellente — 90–99 %',sub:'Très bonne autonomie'},
    fresh:{value:'Batterie neuve — 100 %',title:'Batterie neuve — 100 %',sub:'Capacité maximale'}
  };

  function norm(v){return String(v||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toUpperCase();}
  function code(button){
    var raw=norm(button&&button.getAttribute('data-value'));
    if(raw.indexOf('100 %')>-1)return'fresh';
    if(raw.indexOf('90')>-1)return'excellent';
    return'standard';
  }
  function selectedProperty(picker){
    var active=picker.querySelector('[data-mxp-battery-choice].is-selected,[data-mxp-battery-choice][aria-pressed="true"]');
    return active&&LABELS[code(active)]?LABELS[code(active)].value:LABELS.standard.value;
  }
  function ensureStyle(){
    if(document.getElementById('mxp-iphone16pm-battery-style'))return;
    var style=document.createElement('style');
    style.id='mxp-iphone16pm-battery-style';
    style.textContent='body.template-product .mxp-battery-picker .mxp-battery-choice[disabled]{opacity:1!important;background:#fff!important;color:#111216!important;border-color:#dfe2e6!important;box-shadow:none!important;cursor:not-allowed!important}body.template-product .mxp-battery-picker .mxp-battery-choice[disabled] .mxp-battery-choice__copy strong{color:#111216!important}body.template-product .mxp-battery-picker .mxp-battery-choice[disabled] .mxp-battery-choice__copy small,body.template-product .mxp-battery-picker .mxp-battery-choice[disabled] .mxp-battery-choice__price{color:#7a8089!important}';
    document.head.appendChild(style);
  }
  function sync(){
    var picker=document.querySelector('[data-mxp-battery-picker]');
    if(!picker)return false;
    ensureStyle();
    Array.prototype.forEach.call(picker.querySelectorAll('[data-mxp-battery-choice]'),function(button){
      var key=code(button),data=LABELS[key];if(!data)return;
      if(button.getAttribute('data-value')!==data.value)button.setAttribute('data-value',data.value);
      var strong=button.querySelector('.mxp-battery-choice__copy strong');
      var small=button.querySelector('.mxp-battery-choice__copy small');
      if(strong&&strong.textContent!==data.title)strong.textContent=data.title;
      if(small&&small.textContent!==data.sub)small.textContent=data.sub;
      if(button.disabled)button.setAttribute('aria-disabled','true');else button.removeAttribute('aria-disabled');
    });
    var property=picker.querySelector('[data-mxp-battery-property]');
    if(property)property.value=selectedProperty(picker);
    return true;
  }
  function boot(){
    if(!sync()){setTimeout(boot,40);return;}
    var picker=document.querySelector('[data-mxp-battery-picker]');
    if(picker&&!picker.__mxp16pmObserved){
      picker.__mxp16pmObserved=true;
      new MutationObserver(function(){requestAnimationFrame(sync);}).observe(picker,{subtree:true,attributes:true,attributeFilter:['class','disabled','aria-pressed']});
    }
    var form=picker&&picker.closest('form[data-product-form]');
    if(form&&!form.__mxp16pmBatteryBound){
      form.__mxp16pmBatteryBound=true;
      form.addEventListener('change',function(){setTimeout(sync,0);setTimeout(sync,60);},true);
      form.addEventListener('click',function(event){if(event.target.closest&&event.target.closest('[data-mxp-battery-choice]')){setTimeout(sync,0);setTimeout(sync,60);}},true);
    }
    setTimeout(sync,120);
    setTimeout(sync,350);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',function(){setTimeout(boot,0);});
})();
